import axios from "axios";

let accessTokenGetter = null;

export const setAccessTokenGetter = (getter) => {
  accessTokenGetter = getter;
};

const apiClient = axios.create();

apiClient.interceptors.request.use(async (config) => {
  if (!config.headers) {
    config.headers = {};
  }

  if (!config.headers.Authorization && accessTokenGetter) {
    try {
      const token = await accessTokenGetter();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Allow the request to proceed without a token if retrieval fails.
    }
  }

  return config;
});

export default apiClient;
